import { Card } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Lightbulb, MessageSquare, Target, Sparkles, Search, AlertTriangle } from 'lucide-react';
import { Suggestion } from '@/utils/questionHelpers';

interface SuggestionsListProps {
  suggestions: Suggestion[];
}

export const SuggestionsList = ({ suggestions }: SuggestionsListProps) => {
  const getSuggestionIcon = (type: string) => {
    switch (type) {
      case 'question': return MessageSquare;
      case 'probe': return Search;
      case 'highlight': return Target;
      case 'insight': return Lightbulb;
      case 'warning': return AlertTriangle;
      default: return Sparkles;
    }
  };

  const getSuggestionColor = (priority: string) => {
    switch (priority) {
      case 'high': return 'border-l-red-400 bg-red-50';
      case 'medium': return 'border-l-amber-400 bg-amber-50';
      case 'low': return 'border-l-green-400 bg-green-50';
      default: return 'border-l-gray-400 bg-gray-50';
    }
  };

  if (suggestions.length === 0) {
    return (
      <div className="text-center py-8 text-gray-500">
        <Sparkles className="w-8 h-8 mx-auto mb-2 text-gray-300" />
        <p className="text-sm">Start adding notes to get personalized guidance!</p>
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {suggestions.map((suggestion, index) => {
        const Icon = getSuggestionIcon(suggestion.type);
        return (
          <Card key={index} className={`p-3 border-l-4 ${getSuggestionColor(suggestion.priority)}`}>
            <div className="flex items-start space-x-2">
              <Icon className="w-4 h-4 mt-0.5 text-gray-600" />
              <div className="flex-1">
                <p className="text-sm text-gray-700">{suggestion.content}</p>
                <Badge variant="outline" className="mt-1 text-xs">
                  {suggestion.type}
                </Badge>
              </div>
            </div>
          </Card>
        );
      })}
    </div>
  );
};